import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    FormStore,
    inject,
    Input,
    Modal,
    ModalHandle,
    NothingHere,
    TasksStore,
} from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Form, FormGroup } from 'reactstrap';
import { ClientsStore } from '../Clients/ClientsStore';
import { AppStore } from '../Core/AppStore';
import { ClientRow } from './ClientRow';
import { BsCardHeading } from '@react-icons/all-files/bs/BsCardHeading';

export interface IClientProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class Clients extends React.Component<IClientProps> {
    @action
    public async componentDidMount() {
        try {
            this.loading = true;

            await this.clientsStore.loadClientsAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="col-xs-12 w-100">
                <table className="w-100 table-striped">
                    <thead className="bg-color">
                        <tr>
                            <th className="ps-2 py-3">Client Name</th>
                            <th>Scopes</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from(this.clientsStore.clients, ([k, c]) => (
                            <ClientRow key={k} client={c} />
                        ))}
                    </tbody>
                </table>

                <NothingHere
                    label="There Are No Clients For Your User"
                    empty={!this.clientsStore.clients.size}
                    icon={<BsCardHeading />}
                    loading={this.loading}
                    loadingMessage="Loading Clients..."
                />

                {!!this.addClientForm.globalErrors.length && (
                    <div className="alert-danger p-2">
                        <ul>
                            {this.addClientForm.globalErrors.map((e, idx) => (
                                <li className="text-danger" key={idx}>
                                    {e}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <Form onSubmit={this.submitAsync} className="mt-3">
                    <FormGroup className="d-inline-block">
                        <label>Client ID</label>{' '}
                        <Input
                            type="text"
                            field={this.addClientForm.fields.clientId}
                            placeholder="Client Name"
                            min={5}
                            required
                            className="mx-2 d-inline-block"
                        />
                    </FormGroup>{' '}
                    <FormGroup className="d-inline-block">
                        <button type="submit" className="btn btn-primary mx-2">
                            Create Client
                        </button>
                    </FormGroup>
                </Form>
                <Modal
                    title="Client Created"
                    modalHandle={this.infoModalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div>
                        <p>
                            Your Client Secret: <code>{this.secret}</code>
                        </p>
                        <p>
                            <small>Store encrypted in a safe location. This key can not be retrieved again.</small>
                        </p>
                    </div>
                </Modal>
            </div>
        );
    }

    @bind
    @action
    private async submitAsync(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        this.addClientForm.onSubmit();
        if (this.addClientForm.validate()) {
            const task = this.tasksStore.startSessionTask(`Create Client ${this.addClientForm.fields.clientId.value}`);

            try {
                const secret = await this.clientsStore.addClientAsync(this.addClientForm.values);
                task.complete();

                if (secret) {
                    this.secret = secret;
                    this.infoModalHandle.open();
                }

                this.addClientForm.clear();
            } catch (e: any) {
                if (e.modelState) {
                    this.addClientForm.clearGlobalErrors();
                    this.addClientForm.addErrors(e.modelState);
                }

                task.error(e);
            }
        } else {
            console.log('invalid');
        }
    }

    private readonly addClientForm = new FormStore<Mri.Web.Portal.Controllers.Clients.AddClientModel>({
        clientId: '',
        scopes: ['portal1'],
    });

    @observable
    private secret?: string;
    @observable
    private loading: boolean = false;
    @observable
    private infoModalHandle = new ModalHandle();
    @inject
    private clientsStore!: ClientsStore;
    @inject
    private appStore!: AppStore;
    @inject
    private tasksStore!: TasksStore;
}
